module.exports = __webpack_public_path__ + "img/icons8-worker.30cfcf03.svg";